var map = {
	"./components/mailerlite.js": "./theme/components/mailerlite.js",
	"./components/modal/modal.js": "./theme/components/modal/modal.js",
	"./components/navbar/navbar.js": "./theme/components/navbar/navbar.js",
	"./scripts/test-digestion.js": "./theme/scripts/test-digestion.js",
	"./scripts/test-energy.js": "./theme/scripts/test-energy.js",
	"./scripts/test-weight.js": "./theme/scripts/test-weight.js",
	"./templates/archive-coaches.js": "./theme/templates/archive-coaches.js",
	"./templates/single-coaches.js": "./theme/templates/single-coaches.js",
	"./templates/single-events.js": "./theme/templates/single-events.js",
	"./templates/single-recipes.js": "./theme/templates/single-recipes.js",
	"./templates/single-workshops.js": "./theme/templates/single-workshops.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./theme sync recursive \\.\\/(?%21(dist)).*\\/([^/]+\\/)*.+\\.js$";